const zh = {
  nav: {
    home: '首頁',
    projects: '專案',
    experience: '經歷',
    skills: '技能',
    aiLab: 'AI Lab',
    connect: '聯絡我',
  },
  landing: {
    downloadResume: '下載履歷',
  },
  projects: {
    eyebrow: '精選作品',
    title: '專案展示',
    viewDetails: '查看詳情 →',
    viewAll: '查看所有專案 →',
    archiveEyebrow: '作品典藏',
    archiveTitle: '所有專案',
    filterAll: '全部',
    filterByTag: '依標籤篩選',
    sortNewest: '最新優先',
    sortOldest: '最舊優先',
    sortTitle: '依標題排序',
    countLabel: '個專案',
    noFound: '找不到符合的專案。',
    backToTop: '回到頂部',
  },
  works: {
    eyebrow: '職涯',
    title: '工作經歷',
    viewDetails: '查看詳情 →',
  },
  skills: {
    eyebrow: '技術能力',
    title: '技能與工具',
    languages: '程式語言',
    tools: '工具與基礎設施',
    frameworks: '框架',
    exploring: '正在探索',
  },
  education: {
    eyebrow: '學術背景',
    title: '教育程度',
  },
  contact: {
    eyebrow: '保持聯絡',
    title: '聯絡我',
    subtitle: '有任何想法或合作機會？歡迎隨時與我聯絡。',
    nameLabel: '姓名',
    namePlaceholder: '你的姓名',
    emailLabel: '電子郵件',
    subjectLabel: '主旨',
    subjectPlaceholder: '關於什麼？',
    messageLabel: '訊息',
    messagePlaceholder: '告訴我更多細節...',
    submit: '送出訊息',
  },
  chat: {
    title: 'AI 助手',
    subtitle: '關於 Yu-An 的經歷與專案',
    welcome: '你好！我可以回答關於 Yu-An 的經驗、專案與技能的問題。',
    placeholder: '輸入問題... (Enter 送出)',
    stopTitle: '停止生成',
    stop: '停止',
    clearTitle: '清除對話',
    clear: '清除',
  },
  aiLab: {
    title: 'AI Lab',
    subtitle: 'AI 驅動的工具，內建於此作品集。探索我的經歷如何符合你的需求。',
    jdAnalyzerDesc: '貼上職缺描述，立即分析我的經歷、專案與技能的契合程度。由檢索增強生成（RAG）技術驅動。',
    openJDAnalyzer: '開啟 JD 分析器',
    pinLabel: '輸入 PIN',
    pinError: 'PIN 錯誤',
    devMode: '開發者模式',
  },
  jdAnalyzer: {
    badge: 'AI 動態分析',
    title: 'JD 分析器',
    subtitle: '貼上職缺描述 (JD)，AI 將根據 Yu-An 的經歷進行適配度分析 — powered by RAG。',
    inputLabel: '職缺描述',
    clearTooltip: '清除文字',
    placeholder: '在此貼上職缺要求、職責與資格限制...',
    analyze: '開始分析',
    stop: '停止分析',
    reportTitle: '分析報告',
    generating: '分析中...',
    proTip: '提示：報告中提到的相關專案將會在作品集中自動標示。',
  },
};

export default zh;
